import React, { useEffect, useState } from 'react'
import * as Helpers from '../helpers.mjs'
import { fetchJson } from "../fetch.js"

const BookPackCollage = ({ source, callbackOnLoad }) => {

    const {product_id, title, id } = source;

    const bookpackImageUrl = "/assets/bookpackimage/" + id + ".jpg";
    const isBooksForTopicsPack = (source.origin.replace(/\W+/g, '').toLowerCase() == "booksfortopics");

    const bookPackBadges = [
        "/assets/img/bookPackBadges/blue.png",
        "/assets/img/bookPackBadges/green.png",
        "/assets/img/bookPackBadges/jade.png",
        "/assets/img/bookPackBadges/purple.png",
        "/assets/img/bookPackBadges/red.png",
        "/assets/img/bookPackBadges/steel.png",
        "/assets/img/bookPackBadges/yellow.png"
    ];
    const randomIndex = Math.floor(Math.random() * bookPackBadges.length);
    const randomBookPackBadge = bookPackBadges[randomIndex];

    return <div className="bookPackCollage" key={product_id}>
        <img className="productImg lazy bookImg" src={bookpackImageUrl} title={title} alt={title} onError={(e) => { handleImageError(e.target) }}/>
        <div className="bookBadge bookPackCollage overlay">
            <img className="bookPackBadgeImage" src={isBooksForTopicsPack ? "/assets/img/bookPackBadges/bftBand.png" : randomBookPackBadge} alt="Book pack" />
        </div>
    </div>;
    
    return <img src={bookpackImageUrl}/>

    const [bookPackLinks, setBookPackLinks] = useState([]);
    
    useEffect(() => {
        fetchJson("/product/getBookPackImages/"+id).then(r => {
            setBookPackLinks(r);
        }).then(() => {
            if(callbackOnLoad) {
                callbackOnLoad(true);
            }
        });
    },[]);

    var bookPackImages = [];
    if (bookPackLinks.length > 1) { bookPackLinks.map(b => bookPackImages.push(Helpers.getProductImageLink(b.prEan13))); }
    const shuffledImages = [...bookPackImages].sort(() => 0.5 - Math.random());
    bookPackImages= shuffledImages.slice(0, 9);
}

export default BookPackCollage;